import { render, staticRenderFns } from "./WorkTimeSetupView.vue?vue&type=template&id=a2f89eb8&scoped=true&"
import script from "./WorkTimeSetupView.vue?vue&type=script&lang=ts&"
export * from "./WorkTimeSetupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f89eb8",
  null
  
)

export default component.exports